<span [ngSwitch]="isAuthenticated()">
  <nav class="navbar" [ngClass]="{ borderDiv: isAuthenticated(), navbar1: !isAuthenticated() }">
    <!-- <div class="navbar-header customHeaderNav">
      <a href="#" *ngSwitchCase="false">
        <img src="assets/images/ppm/logo_allianz.png" height="86%" />
      </a>

      <div *ngSwitchCase="true" class="nav-translate">
        <ul class="nav navbar-nav navbar-right customRight loginLogo" *ngIf="true">
          <li class="dropdown">
            <a href="#" class="dropdown-toggle activaLangLogin" data-toggle="dropdown" role="button"
              aria-haspopup="true" aria-expanded="false">{{ translate.currentLang === "en" ? "English" : "Bahasa" }}
              <span class="caret"></span></a>
            <ul class="dropdown-menu">
              <li *ngFor="let lang of langFinal" [jhiActiveMenu]="lang.key">
                <a href="javascript:void(0);" (click)="translate.use(lang.key)">{{ lang.value }}</a>
              </li>
            </ul>
          </li>
        </ul>
        <i *ngSwitchCase="true" class="burger-menu" [ngClass]="!mobileMenu ? 'bi bi-list' : 'bi bi-x-lg' "
          style="font-size: 3rem;padding-right: 5%;" (click)="handleNavMenu()"></i>
      </div>
    </div> -->

    <div class="__top_menu">
      <!-- Allianz Logo -->
      <a href="#" *ngSwitchCase="false">
        <img class="__image_logo" src="assets/images/ppm/logo_allianz.png" />
      </a>
      <!-- Translate dropdown non-login -->
      <div *ngSwitchCase="false">
        <ul class="nav navbar-nav navbar-right customRight __non_login_logo">
          <li class="dropdown text-center">
            <a href="#" class="dropdown-toggle " data-toggle="dropdown" role="button" aria-haspopup="true"
              aria-expanded="false">{{ translate.currentLang === "en" ? "English" : "Bahasa" }}
              <span class="caret"></span></a>
            <ul class="dropdown-menu">
              <li *ngFor="let lang of langFinal" [jhiActiveMenu]="lang.key">
                <a href="javascript:void(0);" (click)="translate.use(lang.key)">{{ lang.value }}</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <div class="__mobile_wrap">
      <!-- Burger menu for mobile -->
      <i *ngSwitchCase="true" class="__burger_menu" [ngClass]="!mobileMenu ? 'bi bi-list' : 'bi bi-x-lg' "
        style="font-size: 3rem;padding-right: 5%;" (click)="handleNavMenu()"></i>
      

            <!-- Translate dropdown login -->
    <ul *ngSwitchCase="true" class="nav navbar-nav navbar-right customRight loginLogo">
      <li class="dropdown ">
        <a href="#" class="dropdown-toggle activaLangLogin" data-toggle="dropdown" role="button" aria-haspopup="true"
          aria-expanded="false">{{ translate.currentLang === "en" ? "English" : "Bahasa" }}
          <span class="caret"></span></a>
        <ul class="dropdown-menu">
          <li *ngFor="let lang of langFinal" [jhiActiveMenu]="lang.key">
            <a href="javascript:void(0);" (click)="translate.use(lang.key)">{{ lang.value }}</a>
          </li>
        </ul>
      </li>
    </ul>
    </div>





    <div class="collapse navbar-collapse" id="myNavbar">
      <!-- <ul class="nav navbar-nav navbar-right rightLangBar" *ngSwitchCase="false">
        <li class="dropdown">
          <a href="#" class="dropdown-toggle activaLang" data-toggle="dropdown" role="button" aria-haspopup="true"
            aria-expanded="false">{{ translate.currentLang === "en" ? "English" : "Bahasa" }}
            <span class="caret"></span></a>
          <ul class="dropdown-menu">
            <li *ngFor="let lang of langFinal" [jhiActiveMenu]="lang.key">
              <a href="javascript:void(0);" (click)="translate.use(lang.key)">{{ lang.value }}</a>
            </li>
          </ul>
        </li>
      </ul> -->


      <!-- profile -->
      <div *ngSwitchCase="true">
        <navbarProfile></navbarProfile>


      </div>


    </div>
  </nav>

  <div *ngSwitchCase="true">
    <div class="idle" *ngIf="idleStatus && idleCountdownLogout <= 30">
      You are currently idle.
      <br />
      <small>Your session will automatically time out in
        {{ idleCountdownLogout }} seconds.</small>
    </div>

    <!-- menu desktop -->
    <navbarMenu></navbarMenu>

    <!-- menu mobile -->
    <app2-nav-mobile *ngIf="mobileMenu" class="mobile-menu" (menuState)="setMenuState($event)"></app2-nav-mobile>
    <!-- <div *ngIf="mobileMenu" class="mobile-menu">
      <nav class="slideInLeft">
        <ul class="list-sidebar bg-defoult" *ngFor="let menu of authenticatedMenus; let i = index;">
          <li *ngIf="menu.title == 'Home'">
            <a class="collapsed active" routerLink="" (click)="handleNavMenu()">
              <span>{{'global.menu.home' | translate}}</span>
            </a>
          </li>
          <li *ngIf="menu.title == 'Balance'">
            <a class="collapsed active" routerLink="balance" (click)="handleNavMenu()">
              <span>{{'global.menu.balance' | translate}}</span>
            </a>
          </li>
          <li *ngIf="menu.title == 'Transaction'">
            <a data-toggle="collapse" data-target="#Transaction" class="collapsed active">
              <span class="nav-label"> {{'global.menu.transaction' | translate }}
              </span>
            </a>
            <span class="bi bi-chevron-down"></span>
            <ul class="sub-menu collapse" id="Transaction">
              <li class="active sub-menu">
                <a routerLink="fund" routerLinkActive="active" (click)="handleNavMenu()">
                  <span> {{ 'global.menu.fund' | translate }} </span>
                </a>
              </li>
              <li class="active sub-menu">
                <a routerLink="unitprice" routerLinkActive="active" (click)="handleNavMenu()">
                  <span> {{ 'global.menu.unit' | translate }} </span>
                </a>
              </li>
            </ul>
          </li>
          <li *ngIf="menu.title == 'Information'">
            <a data-toggle="collapse" data-target="#Information" class="collapsed active">
              <span class="nav-label"> {{
                'global.menu.information' | translate }} </span></a>
            <span class="bi bi-chevron-down"></span>
            <ul class="sub-menu collapse" id="Information">
              <li class="active sub-menu">
                <a (click)="handleNavMenu()" routerLink="faq" routerLinkActive="active"> <span> Faq </span> </a>
              </li>
              <li class="active sub-menu">
                <a (click)="handleNavMenu()" routerLink="document" routerLinkActive="active">
                  <span> {{ 'global.menu.document' | translate }} </span>
                </a>
              </li>
            </ul>
          </li>
          <li *ngIf="menu.title == 'Contact'">
            <a class="collapsed active" routerLink="contact" (click)="handleNavMenu()">
              <span>{{'global.menu.contact' | translate}}</span>
            </a>
          </li>
          <li *ngIf="menu.title == 'Administration'">
            <a data-toggle="collapse" data-target="#Administration" class="collapsed active">
              <span class="nav-label"> {{'global.menu.admin.main'|translate}} </span></a>
            <span class="bi bi-chevron-down"></span>
            <ul class="sub-menu collapse" id="Administration">
              <li class="active sub-menu">
                <a routerLink="fundadmin" routerLinkActive="active">
                  <span> {{'global.menu.addfund'|translate}} </span>
                </a>
              </li>
              <li class="active sub-menu">
                <a routerLink="balance" routerLinkActive="active">
                  <span> {{ 'global.menu.balance' | translate }} </span>
                </a>
              </li>
              <li class="active sub-menu">
                <a routerLink="sendwelcomemail" routerLinkActive="active">
                  <span> {{'global.menu.resendmail'|translate}} </span>
                </a>
              </li>
              <li class="active sub-menu">
                <a routerLink="sendforgotpassword" routerLinkActive="active">
                  <span> {{'global.menu.sendforgot'|translate}} </span>
                </a>
              </li>
              <li class="active sub-menu">
                <a routerLink="sendforgotpassword" routerLinkActive="active">
                  <span> {{'global.menu.resendmail'|translate}} </span>
                </a>
              </li>
              <li class="active sub-menu">
                <a routerLink="userlock" routerLinkActive="active">
                  <span> Unlock User </span>
                </a>
              </li>
            </ul>
          </li>
          <li *ngIf="menu.title == 'Account'">
            <a routerLink="password" routerLinkActive="active" class="collapsed active">
              <span> {{'global.form.changepassword' | translate}} </span></a>
          </li>

          <li *ngIf="menu.title == 'Support'">
            <a routerLink="support/appconfig" routerLinkActive="active" class="collapsed active">
              <span> {{'global.menu.support.appconfig' | translate}} </span></a>
          </li>

          <li *ngIf="menu.title == 'Calculator'">
            <a data-toggle="collapse" data-target="#Calculator" class="collapsed active">
              <span class="nav-label"> Calculator </span></a>
            <span class="bi bi-chevron-down"></span>
            <ul class="sub-menu collapse" id="Calculator">
              <li class="active sub-menu">
                <a routerLink="calculator/pensioncalculator" routerLinkActive="active">
                  <span> {{ 'global.menu.calculatorm' | translate }} </span>
                </a>
              </li>
              <li class="active sub-menu">
                <a routerLink="calculator/pensioncalculatorsetup" routerLinkActive="active">
                  <span> {{ 'global.menu.calculators' | translate }} </span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
        <button class="btn btn-clear btn-block" (click)="logout(0)"> Sign out </button>
      </nav>
    </div> -->

    <div>

    </div>

  </div>
</span>